import { BaseService } from "mrb/core";
import { NakiNigunAlbumTrackProducerApiRouteService } from "common/services";

class NakiNigunAlbumTrackProducerService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new NakiNigunAlbumTrackProducerApiRouteService());
    }

    updateTrackProducers(trackId, resource, abortSignal = null) {
        const url = this.routeService.updateTrackProducers(trackId);
        return this.apiClient.put(url, resource, null, abortSignal);
    }
}

export default NakiNigunAlbumTrackProducerService;
